module.exports = __webpack_public_path__ + "images/dummy_image.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/dummy_image.jpg
// module id = 21
// module chunks = 0